//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vodal from 'vodal'

export default {
  components: {
    Vodal
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },

    video: {
      type: String,
      required: true
    }
  }
}
